import * as React from "react";
const SvgFiBrandsTwitterAltCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-twitter-alt-circle_svg__a)">
      <path d="m6.861 6.16 8.876 11.604h1.36L8.322 6.16z" />
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m3.063 19.232-3.87-5.055-4.422 5.055H4.313l5.733-6.554L4 4.768h5.062l3.494 4.621 4.043-4.621h2.455l-5.361 6.126L20 19.231z" />
    </g>
    <defs>
      <clipPath id="fi-brands-twitter-alt-circle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsTwitterAltCircle;
